import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  // leads properties
  subSource:[],
};

const subSourceData = (state,action) =>{
    return updateObject(state, {
      subSource: action.subSourceArr,
    });
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
      // lead
      case actionTypes.GET_SUB_SOURCE:
          return subSourceData(state,action);
      default:
        return state;
    }
  };
  
  export default reducer;